/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-12 14:23:05
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 16:46:56
 *  */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../../../app/applicationSlice'
import { RootThunkApi } from '../../../../app/store'
import {
  FeesSettingParams,
  getFeesSetting,
  getSaveFeesSetting,
} from '../../../../services/feeSetting'

export const getFeesSettingAsync = createAsyncThunk<any, void, RootThunkApi>(
  'setting/getFeesSettingAsync',
  async (body, api) => {
    return sendAsync(getFeesSetting(), api)
  }
)

export const getSaveFeesSettingAsync = createAsyncThunk<
  void,
  FeesSettingParams,
  RootThunkApi
>('setting/getFeesSettingAsync', async (body, api) => {
  return sendAsync(getSaveFeesSetting(body), api)
})
